// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// required plugins
require('../../../../core/js/plugins/mtc_slick');
require('../../../../core/js/plugins/mtc_tabs');
require('../../../../plugins/Gallery/js/mtc_gallery');

require('../../../../modules/Offers/js/mtc_script')

require('../../../../plugins/BigReveal/js/mtc_reveal')

// TODO this needs improved
require('../site_scripts/mtc_read_more')
require('../site_scripts/mtc_submit_form')
require('../site_scripts/mtc_enquiry_form_overlay')
require('../site_scripts/mtc_finance_video_overlay')
require('../site_scripts/mtc_offers')
require('../site_scripts/mtc_item_back_button')
require('../site_scripts/mtc_add_this_on_demand')
require('../site_scripts/mtc_share_options')
require('../site_scripts/mtc_small_enquiry_form')
require('../site_scripts/mtc_spec_tabs')
require('../site_scripts/mtc_featured_items_carousel')
require('../site_scripts/mtc_grid_scripts');
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')
require('../site_scripts/mtc_spec_accordion_menu')
require('../site_scripts/mtc_legacy_mobile_video_trigger')
require('../franchise/flyout-menu.js')

// functions for old header
require('../site_scripts/mtc_legacy_desktop_menu')
require('../site_scripts/mtc_legacy_mobile_menu')
require('../../../../modules/Search/js/mtc_search')
require('../site_scripts/mtc_show_hide_opening_times')

// carstore / heritage
require('../site_scripts/mtc_slide_out_menu');

// legacy offer specific styles
require('../../css/legacy_offer.less')
